module.exports = __webpack_public_path__ + "static/media/callIcon.6a038bd7.svg";